export const PAYPAL_CLIENT_ID = "AQnCRBfpbLXat58SJLg2XDIMQKvSwSmgqIOMSEmw58Egz68apcqiQEZWi8tGiH92C2SmtbMPTViQJDWj"
export const FACEBOOK_APP_ID = "461547038186504"
export const GOOGLE_CLIENT_ID = "1022741678884-25905ksh92ivm8roko41164f3gt5n6l9.apps.googleusercontent.com"